/* eslint-disable no-unused-vars */

import React, { PureComponent } from 'react';
import cn from 'classnames';
import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import styles from './index.module.scss';

export default class FormCheckbox extends PureComponent {
    render() {
        const {
            input,
            label,
            disabled,
            reqMark,
            globalError,
            meta: { touched, error, dark },
        } = this.props;
        const errorCondition = touched && !!error;

        return (
            <div
                className={cn(styles.formCheckbox, {
                    [styles['formCheckbox--error']]: errorCondition || !!globalError,
                    [styles['formCheckbox--active']]: input.value,
                    [styles['formCheckbox--disabled']]: disabled,
                    [styles['formCheckbox--dark']]: dark,
                })}
            >
                <label className={styles.formCheckbox__box} htmlFor={input.name}>
                    <div className={styles.formCheckbox__dot} />
                    <input
                        {...input}
                        autoComplete="off"
                        type="checkbox"
                        id={input.name}
                        onChange={(e) => input.onChange(!input.value)}
                    />
                    {label && (
                        <div className={styles.formCheckbox__label}>
                            <div>
                                <Translator tk={label} /> {reqMark ? '*' : ''}
                            </div>
                        </div>
                    )}
                </label>
                {errorCondition && (
                    <div className={styles.formCheckbox__error}>
                        <Translator tk={error} />
                    </div>
                )}
            </div>
        );
    }
}
